/**
 * Template icon utility for displaying session template icons.
 * Used by session list components to show template type at a glance.
 */

export const TEMPLATE_ICONS = {
  logline: '🎯',
  character: '👤',
  plot: '📐',
  scene: '🎬',
  world: '🌍',
  problem: '🔧',
  open: '✨'
};

/**
 * Get the icon for a template type.
 * @param {string} template - Template key (e.g., 'character', 'plot')
 * @returns {string} Emoji icon for the template
 */
export const getTemplateIcon = (template) => {
  return TEMPLATE_ICONS[template] || TEMPLATE_ICONS.open;
};

/**
 * Workshop templates — sessions with these templates are Workshop type.
 */
const WORKSHOP_TEMPLATES = [
  'workshop_skeleton', 'workshop_structure', 'workshop_theme', 'workshop_act',
  'workshop_sequence', 'workshop_scene', 'workshop_beat',
  'logline', 'outline_section'
];

/**
 * Derive session type badge from guidance_mode + template.
 * @param {string} guidanceMode - 'explore' or 'focus'
 * @param {string} template - Session template key
 * @returns {{ icon: string, label: string, type: string }}
 */
export const getSessionTypeBadge = (guidanceMode, template) => {
  if (guidanceMode === 'explore') {
    return { icon: '💡', label: 'Explore', type: 'explore' };
  }
  if (guidanceMode === 'focus' && WORKSHOP_TEMPLATES.includes(template)) {
    return { icon: '🏗️', label: 'Workshop', type: 'workshop' };
  }
  return { icon: '🔍', label: 'Focus', type: 'focus' };
};
